import axios from "axios";
import {handleError} from "@/_helpers/utils";
import Vue from "vue";
import {TALENTQ_STORE_NAMES} from "@/stores_new/vacancy_talentq/constants";

export default {
  namespaced: true,
  state () {
    return {
      loaded: false,
      error: null,
      data: null,
    }
  },
  actions: {
    load (context) {
      context.commit('set_loaded', false);
      context.commit('set_error', null);
      return axios.get(`/1.0/talentq/project/list?accountId=${context.getters.account_id}`)
        .then(response => response.data.data)
        .then(data => {
          context.commit('set_data', data);
          context.commit('set_loaded', true);
        })
        .catch(err => {
          err = handleError(err);
          context.commit('set_loaded', true);
          context.commit('set_error', err);
          throw err;
        })
    }
  },
  mutations: {
    set_loaded (state, loaded) {
      state.loaded = loaded;
    },
    set_error (state, error) {
      state.error = error;
    },
    set_data (state, data) {
      state.data = data;
    },
    add_item (state, item) {
      state.data.push(item);
    },
    remove_item (state, id) {
      const pos = state.data.map(item => item.id).indexOf(id);
      if (!~pos) return null;
      state.data.splice(pos, 1);
    },
    set_item_name (state, {id, name}) {
      const item = state.data.find(item => item.id === id);
      Vue.set(item, 'name', name);
    }
  },
  getters: {
    loaded: state => state.loaded,
    error: state => state.error,
    account_id: (state, getters, rootState, rootGetters) => rootGetters['vacancy_talentq/' + TALENTQ_STORE_NAMES.BINDING + '/account_id'],
    data: state => state.data ? state.data : [],
  }
}